// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.leadmanagement.type.SatelliteNextStepType

export enum SatelliteNextStepType {
  ACTION = 'ACTION',
  LINK = 'LINK',
}

export const SatelliteNextStepType_values = [SatelliteNextStepType.ACTION, SatelliteNextStepType.LINK] as const;
